/**
 *
 * @module productRule
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    object
} = Check.assert;

/**
 *
 * @class ProductRule
 * @desc Represents the rules on a product a user is subscribed to.
 *
 */
export default class ProductRule {

    /**
     *
     * @param {Object} ruleObj
     * @param {String} [ruleObj.description]
     * @param {String} [ruleObj.id]
     *
     */
    constructor(ruleObj) {

        const errorMessage = {
            ctor: 'ProductRule({ description, id } = ruleObj)',
            get ruleObj() {
                return `${this.ctor} ruleObj should be a plain Object`;
            }
        };

        object(ruleObj, errorMessage.ruleObj, InvalidArgumentException);

        const { description, id } = ruleObj;

        /**
         *
         * @access private
         * @type {String}
         * @desc Gets the description (optional).
         *
         */
        this.description = description;

        /**
         *
         * @access private
         * @type {String}
         * @desc Gets the ID (optional).
         *
         */
        this.id = id;

    }

}



// WEBPACK FOOTER //
// ./src/services/subscription/productRule.js